module.exports = __webpack_public_path__ + "static/media/error2.78cc1098.svg";